/**
 * CND — Custom Nav Drawer
 * Panels are lazy-loaded on first open via Shopify Sections API.
 */
(function () {
  'use strict';

  var drawer   = document.getElementById('cnd-drawer');
  var overlay  = document.getElementById('cnd-overlay');
  var closeBtn = document.getElementById('cnd-close');
  var tabs     = drawer ? Array.prototype.slice.call(drawer.querySelectorAll('.cnd-tab')) : [];

  if (!drawer) return;

  /* -- 1. Remove FOUC guard ------------------------------------ */
  function removeFoucGuard() {
    var guard = document.getElementById('cnd-fouc-guard');
    if (guard && guard.parentNode) guard.parentNode.removeChild(guard);
    drawer.classList.add('is-ready');
    if (closeBtn) closeBtn.removeAttribute('hidden');
  }

  /* -- 2. Scrollbar width -------------------------------------- */
  var cachedScrollW = null;

  function sbWidth() {
    if (cachedScrollW === null) {
      var w = window.innerWidth - document.documentElement.clientWidth;
      cachedScrollW = (w > 0 ? w : 0) + 'px';
    }
    return cachedScrollW;
  }

  window.addEventListener('resize', function () {
    cachedScrollW = null;
  }, { passive: true });

  /* -- 3. Lazy-load panels on first open ---------------------- */
  var cndPanelsLoaded = false;
  function loadPanels(cb) {
    if (cndPanelsLoaded) { if (cb) cb(); return; }
    var mount = document.getElementById('cnd-panels-mount');
    if (!mount) { cndPanelsLoaded = true; if (cb) cb(); return; }
    fetch('/?sections=custom-drawer-nav-panels')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data['custom-drawer-nav-panels'] || '';
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('#cnd-panels-inner');
        mount.innerHTML = inner ? inner.outerHTML : html;
        cndPanelsLoaded = true;
        if (cb) cb();
      })
      .catch(function() { cndPanelsLoaded = true; if (cb) cb(); });
  }

  /* -- 4. Open ------------------------------------------------- */
  function openDrawer() {
    // Calculate scrollbar width immediately before any DOM mutations invalidate layout
    var scrollW = sbWidth();
    
    loadPanels(function() {
      drawer.style.display = 'flex';
      
      // Defer heavy layout triggers (like body overflow:hidden) to next frame
      requestAnimationFrame(function() {
        document.documentElement.style.setProperty('--cnd-scrollbar-w', scrollW);
        document.body.classList.add('cnd-locked');
        
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        if (closeBtn) closeBtn.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        
        // Defer focus slightly so it doesn't block the animation start (improves INP)
        setTimeout(function() {
          var focus = drawer.querySelector('.cnd-tab.active') || drawer.querySelector('.cnd-tab');
          if (focus) focus.focus({ preventScroll: true });
        }, 50);
      });
    });
  }

  /* -- 5. Close ------------------------------------------------ */
  function closeDrawer() {
    // 1. Immediately start CSS transitions for snappy visual feedback
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    if (closeBtn) closeBtn.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    
    // 2. Defer heavy DOM reflow (unlocking body scroll) until animation finishes
    // This removes the heavy reflow from the interaction frame, greatly reducing INP.
    setTimeout(function() {
      if (!drawer.classList.contains('is-open')) {
        drawer.style.display = 'none';
        document.body.classList.remove('cnd-locked');
        document.documentElement.style.removeProperty('--cnd-scrollbar-w');
      }
    }, 180);
  }

  /* -- 6. Tab activation --------------------------------------- */
  function activateTab(tab) {
    tabs.forEach(function (t) {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
    });
    tab.classList.add('active');
    tab.setAttribute('aria-selected', 'true');

    var panels = drawer.querySelectorAll('.cnd-panel');
    panels.forEach(function (p) { p.classList.remove('active'); });

    var panel = document.getElementById('cnd-panel-' + tab.dataset.panel);
    if (panel) {
      panel.classList.add('active');
      var scroll = panel.querySelector('.cnd-panel-scroll');
      if (scroll) scroll.scrollTop = 0;
    }
  }

  /* -- 7. Keyboard: Escape + focus trap ----------------------- */
  function onKeyDown(e) {
    if (!drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;

    var focusable = Array.prototype.slice.call(
      drawer.querySelectorAll('a[href], button:not([disabled])')
    );
    if (closeBtn) focusable.unshift(closeBtn);
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  }

  /* -- 8. Swipe-to-close --------------------------------------- */
  var tsX = 0, tsY = 0;
  drawer.addEventListener('touchstart', function (e) {
    tsX = e.changedTouches[0].screenX;
    tsY = e.changedTouches[0].screenY;
  }, { passive: true });
  drawer.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].screenX - tsX;
    var dy = Math.abs(e.changedTouches[0].screenY - tsY);
    if (dx < -60 && dy < 80) closeDrawer();
  }, { passive: true });

  /* -- 9. Tab click delegates (works for lazy-loaded tabs too) - */
  drawer.addEventListener('click', function(e) {
    var tab = e.target.closest('.cnd-tab');
    if (tab) activateTab(tab);
  });

  /* -- 9b. Prefetch panels before the user clicks -------------- */
var prefetchStarted = false;
function prefetchPanels() {
  if (prefetchStarted) return;
  prefetchStarted = true;
  loadPanels();
}

document.querySelectorAll('.custom-drawer-trigger').forEach(function (el) {
  el.addEventListener('mouseenter', prefetchPanels, { passive: true, once: true });
  el.addEventListener('touchstart', prefetchPanels, { passive: true, once: true });
});

if ('requestIdleCallback' in window) {
  requestIdleCallback(prefetchPanels, { timeout: 3000 });
} else {
  setTimeout(prefetchPanels, 2000);
}

/* -- 10. Event wiring --------------------------------------- */
document.addEventListener('click', function (e) {
  if (e.target.closest('.custom-drawer-trigger')) { e.preventDefault(); openDrawer(); }
});

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', onKeyDown);

  /* -- 11. Init ----------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeFoucGuard);
  } else {
    removeFoucGuard();
  }

}());
